import { render, staticRenderFns } from "./Alex1Dialog.vue?vue&type=template&id=61b07b35&scoped=true"
import script from "./Alex1Dialog.vue?vue&type=script&lang=js"
export * from "./Alex1Dialog.vue?vue&type=script&lang=js"
import style0 from "./Alex1Dialog.vue?vue&type=style&index=0&id=61b07b35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b07b35",
  null
  
)

export default component.exports